import { 
  DATE_WISE_PRODUCTION_DIFFERENCE_REQUEST, 
  CREATE_DATE_WISE_PRODUCTION_DIFFERENCE, 
  GET_DATE_WISE_PRODUCTION_DIFFERENCES, 
  GET_DATE_WISE_PRODUCTION_DIFFERENCES_PAGE, 
  UPDATE_DATE_WISE_PRODUCTION_DIFFERENCE, 
  DELETE_DATE_WISE_PRODUCTION_DIFFERENCE, 
  DATE_WISE_PRODUCTION_DIFFERENCE_REQUEST_FAILURE, 
  DATE_WISE_PRODUCTION_DIFFERENCE_REQUEST_SUCCESS 
} from '../types';

const initialState = {
  dateWiseProductionDifferences: [],
  dateWiseProductionDifferencesPage: [],
  loading: false,
  error: null,
};


const dateWiseProductionDifferenceReducer = (state = initialState, action) => {
  switch (action.type) {
    case DATE_WISE_PRODUCTION_DIFFERENCE_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_DATE_WISE_PRODUCTION_DIFFERENCES: {
      return {
        ...state,
        dateWiseProductionDifferences: [...action.payload],
        loading: false,
        error: null
      }
    }
    case GET_DATE_WISE_PRODUCTION_DIFFERENCES_PAGE: {
        const { data, total, page, pageSize, search, where } = action.payload || {};
        return {
        ...state,
        dateWiseProductionDifferencesPage: [...data],
        total,
        page,
        pageSize,
        search: search || '',
        where: where || {},
        loading: false,
        error: null
        }
    }
    case CREATE_DATE_WISE_PRODUCTION_DIFFERENCE:
      return {
        ...state,
        dateWiseProductionDifferences: [action.payload, ...state.dateWiseProductionDifferences],
        loading: false,
        error: null
      };
    case UPDATE_DATE_WISE_PRODUCTION_DIFFERENCE:
      const dateWiseProductionDifferencesData = state.dateWiseProductionDifferences.slice(0);
      const uIndex = dateWiseProductionDifferencesData.findIndex((data) => data.id === action.payload.id);
      dateWiseProductionDifferencesData.splice(uIndex, 1, { ...action.payload.data });
      return {
        ...state,
        dateWiseProductionDifferences: [ ...dateWiseProductionDifferencesData ],
        loading: false,
        error: null
      };
    case DELETE_DATE_WISE_PRODUCTION_DIFFERENCE:
      const dateWiseProductionDifferences = state.dateWiseProductionDifferences?.slice(0);
      const index = dateWiseProductionDifferences.findIndex((data) => data.id === action.id);
      if (index > -1) {
        dateWiseProductionDifferences.splice(index, 1);
      }
      return {
        ...state,
        dateWiseProductionDifferences: [...dateWiseProductionDifferences],
        loading: false,
        error: null
      }
    case DATE_WISE_PRODUCTION_DIFFERENCE_REQUEST_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null
      }
    }
    case DATE_WISE_PRODUCTION_DIFFERENCE_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default dateWiseProductionDifferenceReducer;
